import { SVGProps } from 'react';

const ArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.21875 5.37549L2.10938 4.50049L7.46875 9.85986L12.8281 4.50049L13.7187 5.37549L7.91069 11.1835C7.66662 11.4276 7.27089 11.4276 7.02681 11.1835L1.21875 5.37549Z"
      fill="#1F1F1F"
    />
  </svg>
);
export default ArrowIcon;
